import React, { useState } from 'react';
import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import BaseFrame from '@components/settings/components/modules/baseFrame';

import { updateCompanyProfileValue } from '@reducers/membership';

import { languages } from '@helpers';
import { updateLabelSwitchedOn } from '@reducers/language';
import { LABEL_PATTERN, LANGUAGE_LABELS_FEATURE_FLAG } from '@v2/pages/common/constants/base.constants';
import { FeatureFlagsAvailable } from '@components/featureFlags';

const BaseModal = (props) => {
  const {
    user: { featureFlags },
    selectedValue,
    change,
    labelSwitchedOn,
    updateLabelSwitchedOn,
  } = props;

  const data = languages.filter((i) => !i.flag);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selected, setSelected] = useState(selectedValue);

  const onSelect = (item) => {
    setSelected(item.value);
  };

  const onCancel = () => {};

  const onSubmit = async () => {
    setSubmitLoading(true);
    change(selected);
    setSubmitLoading(false);
  };

  const filteredLanguages = labelSwitchedOn
    ? data.filter((l) => l.value.startsWith(LABEL_PATTERN))
    : data.filter((l) => !l.value.startsWith(LABEL_PATTERN));

  const isLanguageLabelsAvailable = FeatureFlagsAvailable(LANGUAGE_LABELS_FEATURE_FLAG, featureFlags);

  return (
    <BaseFrame
      {...{
        submitLoading,
        data: filteredLanguages,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Language',
        selected,
        ...(isLanguageLabelsAvailable ? {footerBlockConfig: {
          title: 'Display Label Numbers',
          description:
            'Display language label numbers to assist with translation. This setting will automatically reset after restarting the app or logging in again.',
          action: updateLabelSwitchedOn,
          height: 55,
          value: labelSwitchedOn,
        }} : {}),
        ...props,
      }}
    />
  );
};

export default connect(({ user, language: { labelSwitchedOn } }) => ({ user, labelSwitchedOn }), {
  updateCompanyProfileValue,
  updateLabelSwitchedOn,
})(ColorWrapper(BaseModal));
